"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _default = exports.default = {
  CloseButton: _styledComponents.default.button`
        width: ${function (_ref) {
    let {
      size
    } = _ref;
    return size || "60px";
  }};
        height: ${function (_ref2) {
    let {
      size
    } = _ref2;
    return size || "60px";
  }};
        position: relative;
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        cursor: pointer;
        z-index: 2;
        ${function (_ref3) {
    let {
      theme
    } = _ref3;
    switch (theme) {
      case "PrimaryBlack":
        return `
                    background: #fff;
                    fill: #000;
                `;
      case "PrimaryWhite":
        return `
                background-color: #000;
                fill: #fff;
                `;
      case "SecondaryBlack":
        return `
                fill: #000;
                background: #fff;
                `;
      case "SecondaryWhite":
        return `
                fill: #fff;
                `;
      default:
        return `
                    background: rgba(56, 56, 56, .6);
                    fill: #fff;
                `;
    }
  }}
        ${function (_ref4) {
    let {
      disableBackground
    } = _ref4;
    return disableBackground && `background: transparent;`;
  }}
    `,
  Icon: _styledComponents.default.svg`
        height: 50%;
        width: 50%;
    `
};